import joints_table from '../data/joint-table.json';
import firebase from "firebase";
import _ from 'lodash';

export const getInches = async (id) => {
    let result = [];

    Object.entries(joints_table).forEach((e) => {
        Object.values(e[1]).forEach((val, index) => {
            if (val.length) {
                result.push({
                    dia: e[0],
                    width: index + 2,
                    inch: val,
                })
            }
        })
    });

    const inches = await myFirestore
        .collection('projects')
        .doc(id)
        .collection('inch').get();

    inches.forEach((subDoc) => {
        const data = subDoc.data()
        const index = result.findIndex((d) => d.width == data.width && d.dia == data.dia);
        if(index !== -1) {
          result[index] = {
            ...data,
            id: subDoc.id
          };
        } else {
          result.push({
            ...data,
            id: subDoc.id
          });
        }
    });

    result = result.map((d) => {
        return {
            ...d,
            width: Number(d.width),
            dia: Number(d.dia),
        }
    })

    return _.orderBy(result, ['dia', 'width'], ['asc', 'asc']);
}



// WEBPACK FOOTER //
// ./src/firestore/inch.js